<template>
  <div style="text-align: center" @click="clickHandler">
    <div :style="{color: numColor,fontSize:option.attribute.numSize+'px',
        lineHeight:option.attribute.numHeight+'px',fontFamily: option.attribute.fontFamily+',serif'}">{{cptData.value?cptData.value:''}}</div>
    <div :style="{color: option.attribute.labelColor,fontSize: option.attribute.labelSize+'px'}">{{option.attribute.title+(cptData.unit?'('+cptData.unit+')':'')}}</div>
  </div>
</template>

<script>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";
import cvNumOption from "@/components/element/attrs/cpt-num-option";
import {compareByOperator} from "@/utils/threshold-compare";

export default {
  name: "cpt-num",
  props: {
    option: Object,
    components: Array, current: Object
  },
  computed:{
    numColor(){
      if(this.alarmed){
        return this.option.attribute.alarmConfig.color
      }else{
        return this.option.attribute.numColor
      }
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  data() {
    return {
      cptData: '',
      uuid: null,
      alarmed: false,
      newData:"",
      jsFunFlag:false,
    }
  },
  watch: {
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    //mark:合并属性，由于属性字段更新，导致旧版本数据不能正常渲染组件或配置表单，所有组件都应执行这项操作！！！
    const temp = JSON.parse(JSON.stringify(cvNumOption.attribute))
    this.option.attribute = Object.assign({}, temp, this.option.attribute);
    
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm,paras) {
      pollingRefresh(this.uuid, cptDataForm, ()=>this.loadData(cptDataForm,paras),this.components)
    },
    loadData(cptDataForm,paras) {
     const that = this;
      getDataJson(cptDataForm,paras,(res)=> {
          that.newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
          that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
          that.processData(cptDataForm,that.newData,that.jsFunFlag)
          // if(res){
          //   this.cptData = res;
          // }else{
          //   this.cptData = {
          //     value:'',
          //     unit:'',
          //   }
          // }
          // const attr = this.option.attribute
          // if(attr.alarmConfig && attr.alarmConfig.threshold){//告警判断
          //   this.alarmed = compareByOperator(attr.alarmConfig.operator,this.cptData.value,attr.alarmConfig.threshold)
          // }
        })
    },
    processData(cptDataForm,res,jsFunFlag,isFromGrid){
      // 第一层判断 如果选择数据集
      if(cptDataForm.dataSource == '4') {
            if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 

        // 第二层判断 ，如果没有配转换脚本
        if(jsFunFlag) { // 没有全部配置映射字段
        //判断此控件在九宫格里面就不请求数据
            if(hasNonEmptyValues(this.option.attribute.cptTableData)) {  
              const dataKey = this.option.attribute.cptTableData;
              // 创建一个新的数组用于存储结果
              let newres = [];
              let newObj = {...res[0]};
            // 如果dataKey中的value有值并且在newObj对象中有对应的值
              dataKey.forEach(item => {
                newObj[item.namekey] = newObj[item.value];
              });
              newres.push(newObj);
              this.cptData = newres[0];
           }
          } else { // 如果配置了转换脚本
            if(res){
            this.cptData = res;
          } else {
            this.cptData = {
              value:'',
              unit:'',
            }
           }
          }
      } else { // 不是数据集类型，是静态数据
        if(res){
            this.cptData = res;
          } else{
            this.cptData = {
              value:'',
              unit:'',
            }
          }
        } 
        const attr = this.option.attribute
        if(attr.alarmConfig && attr.alarmConfig.threshold){//告警判断
          this.alarmed = compareByOperator(attr.alarmConfig.operator,this.cptData.value,attr.alarmConfig.threshold)
        }
    },
    clickHandler(){
      this.$emit("clickHandler",this.option.interaction,"default",this.cptData.value,'cpt-num','',this.current)
    }
  }
}
</script>

<style scoped>

</style>
